import { Dispatch, SetStateAction, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Offer } from "config/api/offers.types";
import ShoppingCartContext from "config/shoppingCartContext";
import SelectedOfferContext from "config/selectedOfferContext";
import Button from "components/common/Button";
import useLocalStorage from "components/hooks/useLocalStorage";
import styles from "./OrderPopupStatus.module.scss";

interface OrderPopupProps {
  setPaymentResultOpen: Dispatch<SetStateAction<boolean>>;
  redirectMessage: boolean;
}

const OrderPupupStatus: React.FC<OrderPopupProps> = ({
  setPaymentResultOpen,
  redirectMessage,
}) => {
  const { setShoppingCartItems } = useContext(ShoppingCartContext);
  const { setSelectedOffer, setOfferArticles } =
    useContext(SelectedOfferContext);
  const orderCreatedId = useLocalStorage("orderId", []).storedValue;
  const setOrderId = useLocalStorage("orderId", []).setValue;
  const navigate = useNavigate();
  const orderResultSuccess = orderCreatedId.length ? true : false;

  const orderSuccessMessage = orderResultSuccess ? (
    <div>
      <img alt="Payment success" src={"/openpay/paysuccess.png"} />
      <p className={styles["main-message"]}>
        <strong>¡Muchas gracias por comprar con nosotros!</strong>
      </p>
      <p className={styles["sub-message"]}>
        Pronto recibirás por correo electrónico la confirmación de tu compra y
        el id. de fabricación correspondiente para el seguimiento de tu pedido.
      </p>
      <div className={styles["buttons-wrapper"]}>
        <Button
          color="primary-filled"
          border={false}
          action={() => {
            setShoppingCartItems([]);
            setSelectedOffer({} as Offer);
            setOfferArticles([]);
            setOrderId("");
            navigate("../");
          }}
        >
          <p>Ir a la página principal</p>
        </Button>
      </div>
    </div>
  ) : null;

  const orderFailedMessage = !orderResultSuccess ? (
    <div>
      <img alt="Payment error" src={"/openpay/payerror.png"} />
      <p className={styles["main-message"]}>
        <strong>¡Ups!</strong>
      </p>
      <p className={styles["sub-message-error"]}>
        Se ha producido un error pero ya lo estamos solucionando. Por favor,
        vuelve a intentarlo más tarde.
      </p>
      <div className={styles["buttons-wrapper"]}>
        <Button
          color="primary"
          action={() => {
            setPaymentResultOpen(false);
          }}
        >
          <p>Volver a intentar</p>
        </Button>
      </div>
    </div>
  ) : null;

  const orderRedirectMessage = redirectMessage ? (
    <div>
      <img alt="Payment success" src={"/openpay/payguardsuccess.png"} />
      <p className={styles["main-message"]}>
        <strong>Pago Seguro</strong>
      </p>
      <p className={styles["sub-message-green"]}>
        Te redirigiremos a un sitio web para completar tu pago y asegurarnos que
        tus datos estén protegidos.
      </p>
      <div className={styles["buttons-wrapper"]}>
        <Button
          color="primary"
          border={false}
          loading
          loadingColor="blue"
          action={() => {}}
        ></Button>
      </div>
    </div>
  ) : null;

  return (
    <div className={styles.container}>
      {redirectMessage
        ? orderRedirectMessage
        : orderResultSuccess
        ? orderSuccessMessage
        : orderFailedMessage}
    </div>
  );
};

export default OrderPupupStatus;
